module.exports = __webpack_public_path__ + "img/shopping_application_1-1.8668dfab.jpg";